import styled, { css } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Icon24 from 'builder/components/Icon'
import Media from 'builder/styles/media'

export const Wrapper = styled.div<{ $width: number; $padding?: string; $fullScreen?: boolean }>`
  background-color: ${Colors.White};
  width: ${({ $width }) => $width}px;
  border-radius: 12px;

  ${Media.Phone`
    max-width: none;
    padding: 20px;
  `};

  ${({ $fullScreen }) =>
    $fullScreen &&
    css`
      position: fixed;
      bottom: 0;
    `}

  padding: ${Spacing.L};
`
export const CloseIconContainer = styled.div`
  margin-left: 16px;
  height: 28px;
  width: 28px;
  flex: 0 0 auto;
  background-color: ${Colors.Neutral10};
  color: ${Colors.Neutral50};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${Colors.Blue50};
    background-color: ${Colors.Blue10};
  }

  ${Media.Phone`
    height: 24px;
    width: 24px;
  `}
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${Spacing.XS};

  ${Media.Phone`
    margin-bottom: ${Spacing.XS};

  `}
`

export const Title = styled.div`
  ${Typography.S};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
`

export const CloseIcon = styled(Icon24.Close)`
  height: 20px;
  width: 20px;
`
export const Subtitle = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`
